import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  // Auth
  LoginPage,
  // Dashboard: General
  GeneralAppPage,
  GeneralEcommercePage,
  GeneralAnalyticsPage,
  GeneralWithdrawPage,
  EcommerceShopPage,
  //
  Page404,
  NetworkError,
  GeneralPartnersPage,
  PartnerPage
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },

    // Dashboard
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <GeneralAppPage /> },
        { path: 'stats', element: <GeneralEcommercePage /> },
        { path: 'withdraw', element: <GeneralWithdrawPage /> },

        {
          path: 'pr',
          children: [
            { element: <Navigate to="/dashboard/pr/materials" replace />, index: true },
            { path: 'materials', element: <EcommerceShopPage /> },
          ],
        },
        {
          path: 'partners',
          children: [
            { element: <Navigate to="/dashboard/partners/list" replace />, index: true },
            { path: 'list', element: <GeneralPartnersPage /> },
            { path: ':name', element: <PartnerPage /> },
          ],
        },
        {
          path: 'analytics',
          children: [
            { element: <GeneralAnalyticsPage />, index: true },
          ],
        },
        
      ],
    },
    {
      path: '/', element: <Navigate to="/auth/login" replace />
    
    },
    
    {
      element: <CompactLayout />,
      children: [
        { path: '404', element: <Page404 /> },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: 'network-error', element: <NetworkError /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
